import { flip, offset } from '@floating-ui/react';
import { MenuProvider, useMenu } from '@mui/base';
import { Popup } from '@mui/base/Unstable_Popup/Popup';
import cn from 'classnames';
import { forwardRef } from 'react';

import type { ForwardedRef, PropsWithChildren } from 'react';

import type { MenuContentProps } from './menu-content.types';

import './menu-content.scss';

const MenuContent = forwardRef(
  (props: PropsWithChildren<MenuContentProps>, forwardedRef: ForwardedRef<HTMLDivElement>): JSX.Element => {
    const { children, className, placement = 'bottom-end' } = props;

    const { contextValue, getListboxProps, listboxRef, open, triggerElement } = useMenu({
      disabledItemsFocusable: false,
      listboxRef: forwardedRef,
    });

    const listBoxProps = getListboxProps();

    const classes = cn('rbui-menu-content', className);

    return (
      <MenuProvider value={contextValue}>
        <Popup
          anchor={triggerElement}
          middleware={[offset(4), flip()]}
          open={open}
          placement={placement}
          style={{ display: open ? 'block' : 'none' }}
        >
          <ul {...listBoxProps} className={classes} ref={listboxRef}>
            {children}
          </ul>
        </Popup>
      </MenuProvider>
    );
  },
);

MenuContent.displayName = 'MenuContent';

export default MenuContent;
